import React from "react";

// See more loading icons here:
// https://fontawesome.com/how-to-use/on-the-web/styling/animating-icons
const PageLoader = () => {
    const styles = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        flexDirection: "column",
    };

    return (
        <div
            className="page-loader"
            style={styles}
        >
            <div>
                <img src="img/logo-csr.png" alt="Logo Clínica San Rafael" />
            </div>
            <div>
                <em className="fas fa-circle-notch fa-spin fa-2x text-muted text-secondary"></em>
            </div>
        </div>
    );
};

export default PageLoader;
